<template>
    <div id="home-swiper">
        <swiper ref="swiper" v-if="banners.length">
            <Slide v-for="(item,index) in banners" :key="index">
                <a :href="item.image" >
                    <img :src="item.image" @load="imageLoad">
                </a>
            </Slide>
        </swiper>
    </div>
</template>

<script>
    import {Swiper,Slide} from '../../../components/common/swiper'
    export default {
        name: "HomeSwiper",
        components: {Slide, Swiper},
        comments: {
            Swiper,
            Slide,
        },
        props:{
            banners:{
                type:Array,
                default:[]
            }

        },
        data(){
            return{
                isLoad: false,
            }
        },
        methods:{
            imageLoad(){
                if(!this.isLoad){
                    this.$emit('swiperImageLoad');
                    this.isLoad=true;
                }
            },
            stopTimer(){
                this.$refs.swiper.stopTimer()
            },
            startTimer(){
                if(this.$refs.swiper){
                    this.$refs.swiper.startTimer()
                }
            }
        }
    }
</script>

<style scoped>

</style>